import { render, staticRenderFns } from "./LayoutBauvorhaben.vue?vue&type=template&id=ed7af2c6&scoped=true"
import script from "./LayoutBauvorhaben.vue?vue&type=script&lang=js"
export * from "./LayoutBauvorhaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7af2c6",
  null
  
)

export default component.exports